export const parsePartStateIntegerValue = (isWantingNewPart, isWantingUsedPart) => {
    const newPartSelected = isWantingNewPart;
    const usedPartSelected = isWantingUsedPart;

    let parsedValue = null;

    const caseOne = (newPartSelected && usedPartSelected);
    const caseTwo = (newPartSelected && !usedPartSelected);
    const caseThree = (!newPartSelected && usedPartSelected);

    if (caseOne) {
        parsedValue = 0;
    }

    else if (caseTwo) {
        parsedValue = 1;
    }

    else if (caseThree) {
        parsedValue = 2;
    };

    if (parsedValue === null) {
        throw new Error('Failed to parse partstate integer value');
    };

    return parsedValue;
};